import React from "react";
import { AlertTriangle, RefreshCw } from "lucide-react";
import { Btn, Vazio } from "./componentes";

/**
 * Erro em uma tela fica na tela.
 *
 * Sem isto, qualquer exceção durante o render desmonta o React inteiro e a
 * oficina vê uma página em branco — sem menu, sem botão, sem mensagem. Foi
 * assim em 16/10: um veículo fora da lista derrubou o painel, e o painel é a
 * primeira tela depois do login. O dono ligou achando que o sistema tinha
 * caído, e o servidor estava respondendo 200 em tudo.
 *
 * Com a proteção, o menu continua de pé, as outras telas abrem, e a mensagem
 * diz o que fazer. Tem que ser classe: React não tem hook para isso.
 */
export class ProtecaoErro extends React.Component {
  state = { erro: null };

  static getDerivedStateFromError(erro) {
    return { erro };
  }

  componentDidCatch(erro, info) {
    // Sem rastreador de erros em produção, o console é onde o suporte olha.
    console.error("Tela quebrou:", erro, info.componentStack);
  }

  render() {
    if (!this.state.erro) return this.props.children;
    // Peças pequenas do cabeçalho (o sino) somem em vez de ocupar espaço.
    if (this.props.silencioso) return null;
    return (
      <div className="card">
        <Vazio icon={AlertTriangle} titulo="Esta tela encontrou um problema"
          msg="Os seus dados estão salvos. Use o menu para abrir outra tela, ou recarregue a página. Se continuar, avise o suporte."
          acao={<Btn variant="s" size="sm" icon={RefreshCw} onClick={() => window.location.reload()}>Recarregar</Btn>} />
      </div>
    );
  }
}
